// extracted by mini-css-extract-plugin
export default {"icon":"landpageStepIcons_icon__C0gZC"};